export const chat = [
  {
    path: '/chat/chat',
    name: 'ChatService',
    component: resolve => require(['@pages/main/chat/Chat'], resolve),
    meta: {auth: true}
  },
  {
    path: '/chat/new',
    name: 'ChatNewService',
    component: resolve => require(['@pages/main/chat/New'], resolve),
    meta: {auth: true}
  },
  {
    path: '/chat/detail/:id',
    name: 'ChatDetail',
    component: resolve => require(['@pages/main/chat/Detail'], resolve),
    meta: {auth: true}
  }
]



// WEBPACK FOOTER //
// ./src/router/mod/chat.route.js